module.exports = __webpack_public_path__ + "assets/good_feedback.58da2996.svg";